/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {PersonAutocompleteResourceService} from './person-autocomplete-resource.service';
import {PersonAutocompleteVoModel} from './person-autocomplete-vo.model';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PersonAutocompleteService {
  constructor(private personAutocompleteResourceService: PersonAutocompleteResourceService) {
  }

  findAll(query: any): Observable<PersonAutocompleteVoModel[]> {
    return this.personAutocompleteResourceService
      .findAll(query)
      .pipe(map(res => res.data));
  }
}
